export default __webpack_public_path__ + "static/media/profile-share-icon.e869ca58.svg";